import { render, staticRenderFns } from "./relatedProductsDrawer.vue?vue&type=template&id=541d35c8&scoped=true"
import script from "./relatedProductsDrawer.vue?vue&type=script&lang=js"
export * from "./relatedProductsDrawer.vue?vue&type=script&lang=js"
import style0 from "./relatedProductsDrawer.vue?vue&type=style&index=0&id=541d35c8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541d35c8",
  null
  
)

export default component.exports